// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2Uuqv","list":"PatternAutocomplete_list__2Rby9"};